import {
  ArrowClockwise, Buildings, CaretLeft, CaretRight, CornersIn, CornersOut,
  DotsThreeVertical, Gear, Globe, LinkSimple, List, LockKey, MagnifyingGlass, Moon, Plus,
  Power, Sun, Table, User, Users, X, BookOpen, BellRinging, ChatText, Envelope, ChartBar,
} from "@phosphor-icons/react";
import { Button, Tooltip } from "antd";
import type { ComponentProps } from "react";

// Glyphs and weights mirror raj-dar-web's semantic icon registry.
const icons = {
  sms: ChatText, invitations: Envelope,
  companies: Buildings, domains: Globe, connections: LinkSimple, keys: LockKey,
  administrators: Users, settings: Gear, search: MagnifyingGlass,
  guides: BookOpen,
  notifications: BellRinging, emails: Envelope,
  "login-usage": ChartBar,
  refresh: ArrowClockwise, fullscreen: CornersOut, exitFullscreen: CornersIn,
  close: X, add: Plus, collapse: CaretRight, expand: CaretLeft,
  menu: List, logout: Power, profile: User,
  sun: Sun, moon: Moon, previous: CaretRight, next: CaretLeft, group: Table,
  more: DotsThreeVertical,
};

const weights: Partial<Record<keyof typeof icons, ComponentProps<typeof Table>["weight"]>> = {
  collapse: "bold",
  expand: "bold",
  fullscreen: "duotone",
  exitFullscreen: "duotone",
  sun: "duotone",
  moon: "duotone",
  logout: "duotone",
  add: "bold",
};

export function PlatformAdminIcon({ name, size = 20 }: {
  name: keyof typeof icons;
  size?: number;
}) {
  const Icon = icons[name];
  return (
    <Icon
      size={size}
      weight={weights[name] || "regular"}
      aria-hidden="true"
      focusable="false"
    />
  );
}

export function PlatformIconButton({ label, icon, iconSize = 20, ...props }: Omit<ComponentProps<typeof Button>, "icon"> & {
  label: string;
  icon: keyof typeof icons;
  iconSize?: number;
}) {
  return (
    <Tooltip title={label}>
      <Button
        {...props}
        type={props.type || "text"}
        icon={<PlatformAdminIcon name={icon} size={iconSize} />}
      >
        <span className="platform-admin__sr-only">{label}</span>
      </Button>
    </Tooltip>
  );
}
